import { createContext } from "react";

export const GuestContext = createContext({});
